import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '@core/auth/authentication.service';
import { ThemeService } from 'src/app/theme.service';

@Component({
  selector: 'app-menu-header',
  templateUrl: './menu-header.component.html',
  styleUrls: ['./menu-header.component.scss']
})
export class MenuHeaderComponent implements OnInit {

  @Input() isCollapsed: boolean = false;
  theme: boolean = false;
  dadosUser: any;

  constructor(
    private themeService: ThemeService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    
    this.dadosUser = this.authenticationService.currentUserValue;
  }

  toggleTheme(): void {
    this.theme = !this.theme;
    this.themeService.toggleTheme().then();
  }
}
